/********************************************************
* Option Group Control
*
* module handles listeners on option group button and panel tab
* module also controls accordian and scrollbar for panel
*
********************************************************/



/**********************************************
 DEPENDENCIES
**********************************************/
var $ = require('jquery');
var utils = require('Utilities/utils');
var sb = require('Modules/scroller');


/**********************************************
 Variable Declarations
**********************************************/
var self = {};
var listener = false;
var listener_cb;
var og_sb;




/**********************************************
 Private Functions
**********************************************/

// option group tab in mobile view clicked, toggle option group panel view
var option_group_tab_clicked = function(e) {
	clean_event(e);

	// if instructions show, remove them
	$('.og-user-instructions').addClass('og-user-instructions--hide');

	// toggle class on panel to hide or show
	$('.og-panel').toggleClass('og-panel--slide-out');

	// scroll back into proper position on page
	$('html, body').animate({scrollTop: $('.vdm-container').offset().top}, 500);
}


// option group accordian button clicked so toggle state
var option_group_clicked = function(e) {
	clean_event(e);
	var $this = $(this);

	// if option group item open then close
	if ($this.hasClass('og-item--active')) {
		$('.og-item--active').removeClass('og-item--active');
		$this.find('.og-item__section').slideUp();	
	}
	// else open option group up
	else {
		$('.og-item--active .og-item__section').slideUp(250);
		$('.og-item--active').removeClass('og-item--active');
		$this.addClass('og-item--active');
		$this.find('.og-item__section').slideDown(250);
	}
}


// option item clicked, grab info and let cb know if one exists
var option_item_clicked = function(e) {
	clean_event(e);
	var $this = $(this);

	// get selected option id
	var opt_id = $this.attr('data-option-id');

	// get option group id that option belongs to
	var $og = $this.closest('.og-item');
	var opt_grp_id = $og.attr('data-og-id');

	// fire listener call back with info
	if (listener) {
		if (listener_cb) listener_cb(opt_grp_id, opt_id);
	}
}


// stop event cold in it's tracks!
var clean_event = function(e) {
	e.preventDefault();
	e.stopPropagation();
}



/**********************************************
 Public Functions
**********************************************/

// when option panel populated add listeners and compact acoordian
self.init = function() {
	$('.og-item--active').removeClass('og-item--active');

	// clean up old stuff if needed
	self.kill();

	// compact accordian
	$('.og-item__section').slideUp(0);

	// add listener to mobile view tab button
	$('.og-panel__tab').on('click', option_group_tab_clicked);

	// add listener to option group accordian button
	$('.og-item').on('click', option_group_clicked);

	// add listener to options
	$('.ol-item').on('click', option_item_clicked);

	og_sb = new sb({
		element : 'og_container',
		scrolldrag : 'og_sb_drag',
		scrolltrack : 'og_sb_track',
		//clickdrag : true,
		canresize : true,
		containhide : true
	});
}


// method that allows callback function to be defined when value changes
self.on_change = function(cb) {
	listener = true;
	listener_cb = cb;
}


// method to stop reporting of value change
self.stop_listen = function() {
	listener = false;
	listener_cb = null;
}


// remove button listeners
self.kill = function() {
	if (og_sb) og_sb.kill();
	$('.og-panel__tab').off();
	$('.og-item').off();
	$('.ol-item').off();
}



/**********************************************
 Module Export
**********************************************/
module.exports = self;